<template>
    <div id="editor_textChapter" v-if="btnStatus != 2">
        <div class="editor_text">
            <div class="editor_text1">
                <div class="editor_text2">字数 {{ overview.length }}</div>
                <div class="editor_text2_1">
                    <textLoading v-if="streamStatus"></textLoading>
                    <div @click="again" class="cursor_1" v-if="!streamStatus && !editorStatus">
                        换一换</div>
                </div>
            </div>
            <div class="cursor_1" :class="editorStatus ? 'editor_text3' : 'editor_textChapter1'"
                v-if="[1, 3].includes(btnStatus)" @click="nextContent(3)">
                {{ editorStatus ? '编辑' : '保存' }}
            </div>
        </div>

        <div class="editor_textChapter2" ref="editorTextContext1">
            <div class="editor_textChapter2_1">作品章纲</div>
            <el-input type="textarea" :autosize="{ minRows: 2 }" :maxlength="5000" :disabled="editorStatus"
                :placeholder="placeholder" v-model="overview" ref="textareaRef"></el-input>
            <!-- 停止生成按钮 -->
            <AIStopCreate :hide="streamStatus"></AIStopCreate>
        </div>

        <template v-if="btnStatus !== 1">
            <!-- 如果章节是第一章 -->
            <div class="editor_textChapter3" v-if="chapter === 1">
                <div @click="nextContent(0)" class="chapter-lg t-m-r-18">
                    <img src="@/assets/image/ai_outline/icon1.png" width="21" height="23" />
                    <span class="t-m-l-8">灵感开头</span>
                </div>
                <div @click="nextContent(1)" class="chapter-bk tech-bg-primary">
                    <img src="@/assets/image/ai_outline/icon2.png" width="22" height="24" />
                    <span class="t-m-l-11">爆款开头</span>
                    <span class="chapter_vip">vip</span>
                </div>
            </div>
            <!-- 如果章节不是第一章 -->
            <div class="editor_textChapter4" v-else>
                <!-- <div class="editor_textChapter4_1 cursor_1" @click="again">换一换</div> -->
                <!-- <el-button  plain class="editor_textChapter4_1" @click="again">换一换</el-button> -->
                <div class="editor_textChapter4_2 cursor_1" @click="nextContent(2)">
                    下一步:AI生成正文
                </div>
            </div>
        </template>

        <template v-if="btnStatus === 2">
            <div class="editor_textChapter4">
                <!-- <div v-if="headStatus" class="editor_textChapter4_1 cursor_1" @click="again">
                    换一换
                </div> -->
                <!-- <el-button v-if="headStatus" plain class="editor_textChapter4_1" @click="again">换一换</el-button> -->
                <el-button class="editor_textChapter4_1_1 cursor_1" type="warning" @click="headWrite">
                    <span>{{ editorStatus ? '编辑' : '保存' }}</span>
                </el-button>
                <!-- <div class="editor_textChapter4_1_1 editor_textChapter4_3 cursor_1" >
                    {{ editorStatus ? '编辑' : '保存' }}
                </div> -->
            </div>
        </template>
        <delPopup ref="delPopup"></delPopup>
        <textRequire ref="textRequire"></textRequire>
        <editorChapterRequire ref="editorChapterRequire"></editorChapterRequire>
    </div>
</template>

<script>
import { EventBus } from '@/utils/eventBus'
import api from '@/api/api'
import lNApi from '@/api/longNovel'
import delPopup from '@/components/del_popup.vue';
import textRequire from '@/components/text_require.vue'// 要求
import editorChapterRequire from '@/components/editor_chapter_require.vue' //换一换要求
import textLoading from '@/components/text_loading.vue';
export default {
    components: {
        delPopup, textRequire, textLoading,editorChapterRequire
    },
    data() {
        return {
            userInfo: {},//用户信息
            placeholder: '请输入章纲内容或者选择AI生成章纲',
            placeholder1: '在这里填写你希望出现的情节、人设或风格，AI 会根据这些信息生成更贴合你想法的正文内容。 (仅作用于当前章节的正文)',
            overview: '', //章节概述
            contentRequire: '',//作品要求
            headStatus: false, // 手写 --> ai生成章纲状态
            btnStatus: null, // 1编辑 2手写 3AI生成
            editorStatus: false, // 1状态 编辑状态 true不可编辑  false可编辑
            ifeditorStatus: false, //是否点过编辑
            chapter: null, // 章节
            streamStatus: false, // 流式请求 false请求结束 true请求
            streamIndex: 0, // 流式请求下标
            streamLast: false, //流式最后一条
            debounceTimer: null, // 防抖定时器
            typingTimer: null, // 打字效果定时器
            textareaRef: null, // 文本域容器引用（用于滚动定位）
            editItem: JSON.parse(sessionStorage.getItem('editItem')), //编辑信息系
            isStop: false //是否停止
        }
    },
    mounted() {
        EventBus.$on('disableChapter', () => {
            this.editorStatus = true
        })
        EventBus.$on('refresh', () => {
            this.init()
        })
        //换一换
        EventBus.$on('editor_chapter_hyh', (requirement) => {
            sessionStorage.setItem('ifEditor', true)
            this.isStop = false
            this.overview = ''
            this.createChapter(requirement)
        })
        EventBus.$on('saveChapterContent', () => {
            if (!this.editorStatus) {
                const editItem = JSON.parse(sessionStorage.getItem('editItem'))
                let params = {
                    id: editItem.chapterId,
                    overview: this.overview,
                    requirement: this.contentRequire
                }

                lNApi.longChapterOverviewSave(params).then((res) => {
                    if (res.code == 200) {
                        this.editorStatus = true
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
            }
        })
    },
    beforeDestroy() {
        EventBus.$off('disableChapter');
        EventBus.$off('refresh');
        EventBus.$off('saveChapterContent')
        EventBus.$off('editor_chapter_hyh')
        this.clearTimer()
    },
    created() {
        this.init()
    },
    methods: {
        init() {
            const editItem = JSON.parse(sessionStorage.getItem('editItem'))
            console.log('editItem=', editItem)
            if (editItem.id) {
                this.btnStatus = editItem.editText
                this.chapter = editItem.chapter
                this.getUserinfo()
                this.mixinNovelInfo(editItem.id, 'lnovel')
                setTimeout(() => {
                    this.getoverview(this.btnStatus)
                }, 200);
            }

        },
        clearTimer(status) {
            console.log('销毁定时器')
            if (status) {
                this.isStop = true
            }
            clearTimeout(this.debounceTimer)
            clearInterval(this.typingTimer)
            this.streamIndex = 0
            this.streamStatus = false;
            this.streamLast = false;
            sessionStorage.removeItem('streamStatus')
        },
        getUserinfo() {
            api.getUserinfo().then((res) => {
                // console.log(res)
                if (res.code == 200) {
                    this.userInfo = res.data
                }
            })
        },
        getoverview(i) {
            const editItem = JSON.parse(sessionStorage.getItem('editItem'))
            //编辑
            if (i == 1) {
                //章节详情
                lNApi.longChapterDetail({ chapterId: editItem.chapterId }).then((res) => {
                    if (res.code == 200) {
                        if (res.data) {
                            this.overview = res.data.overview || ''
                            this.editorStatus = true
                        } else {
                            this.editorStatus = false

                        }
                    }
                })
            }
            //手写
            else if (i == 2) {
                this.editorStatus = true
            }
            //ai帮写
            else if (i == 3) {
                //章节详情
                lNApi.longChapterDetail({ chapterId: editItem.chapterId }).then((res) => {
                    if (res.code == 200) {
                        if (res.data) {
                            this.overview = res.data.overview || ''
                            if (!this.overview) {
                                this.editorStatus = false
                                this.createChapter()
                                return
                            }
                            // this.editorStatus = true
                        } else {
                            this.createChapter()
                            this.editorStatus = false
                        }
                    }
                })

            }
        },
        // AI生成章纲
        createChapter(requirement) {
            this.streamStatus = true
            const editItem = JSON.parse(sessionStorage.getItem('editItem'))
            let oneType = ''
            if (editItem.chapter == 1) {
                oneType = 'lnovel_start_overview'
            } else {
                //是专业vip还有用户已经开启了长记忆就走长记忆的流式
                if (this.zsVip(this.userInfo) && this.isOpenRecall(this.mixinNInfo)) {
                    oneType = 'lnovel_recall_overview'
                } else {
                    oneType = 'lnovel_overview'
                }
            }
            let params = {
                novelId: editItem.id,
                series: editItem.seriesNum,
                chapter: editItem.chapter,
                requirement,
            }
            this.AIWrite({
                length: '长',
                haveId: true,
                type: oneType,
                params: params,
                success: (res) => {
                    this.streamIndex = 0
                    this.streamStatus = true
                    sessionStorage.setItem('streamStatus', this.streamStatus)
                    localStorage.setItem('AICreateId', res.data)
                    this.getStreamContent(res.data)
                }
            })
            // lNApi.longNovelHelpWriteId(oneType, {
            //     novelId: editItem.id,
            //     series: editItem.seriesNum,
            //     chapter: editItem.chapter,
            //     requirement: '',
            // }).then((res) => {
            //     if (res.code === 200) {
            //         this.streamStatus = true
            //         sessionStorage.setItem('streamStatus', this.streamStatus)
            //         localStorage.setItem('AICreateId', res.data)
            //         this.getStreamContent(res.data)
            //     } else {
            //         this.$message.warning(res.msg)
            //     }

            // })
        },
        getStreamContent(id) {
            // 清除之前的定时器
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer)
            }
            this.debounceTimer = setTimeout(() => {
                api.getStreamContent(id, this.streamIndex).then((res) => {
                    if (res.code === 200) {
                        if (res.data && res.data.length !== 0) {
                            this.streamIndex = this.streamIndex + res.data.length
                            let combinedText = ''
                            res.data.map((item) => {
                                if (item !== '[DONE]') {
                                    combinedText += item
                                }
                            })
                            this.typeText(combinedText, () => {
                                if (res.data[res.data.length - 1] === '[DONE]') {
                                    this.streamIndex = 0
                                    this.streamLast = true
                                }
                                if (this.streamLast) {
                                    this.clearTimer();
                                    //刷新用户信息-基础会员字符刷新
                                    this.getUserInfo()
                                    this.$message.success('AI生成完成！');
                                } else {
                                    this.getStreamContent(id);
                                }
                            })
                        } else {
                            this.getStreamContent(id)
                        }
                    } else {
                        this.$message.warning(res.msg)
                        this.clearTimer()
                    }
                }).catch(() => {
                    this.clearTimer()
                })
            }, 500)
        },
        // 打字效果
        typeText(text, callback) {
            let index = 0
            if (this.typingTimer) {
                clearInterval(this.typingTimer)
            }
            this.typingTimer = setInterval(() => {
                if (index < text.length) {
                    this.overview += text[index]
                    index++
                    this.$nextTick(() => {
                        const container = this.$refs.editorTextContext1;
                        if (container) {
                            container.scrollTop = container.scrollHeight; // 直接滚动到底部
                        }
                    });
                } else {
                    clearInterval(this.typingTimer)
                    if (callback) {
                        callback()
                    }
                }
            }, 20)
        },
        // ai生成章纲
        aiChapter() {
            if (sessionStorage.getItem('streamStatus') || this.streamStatus) {
                this.$message.warning('请等待Ai生成完毕！')
                return
            }
            sessionStorage.setItem('ifEditor', true)
            this.overview = ''
            this.createChapter()
            this.headStatus = true
        },
        // 编辑
        nextContent(i) {
            if (sessionStorage.getItem('streamStatus') || this.streamStatus) {
                this.$message.warning('请等待Ai生成完毕！')
                return
            }
            //点击编辑先出来弹窗提示，然后按钮变成保存
            if (i === 3 && this.editorStatus) {
                this.editorStatus = false
                EventBus.$emit('disable')
                this.$refs.delPopup.openPrompt(7)
                sessionStorage.setItem('ifEditor', true)
            } else {
                //显示编辑里面的按钮操作
                if (this.userInfo.vipType == 'common' && i == 1) {
                    EventBus.$emit('openVip')
                    return
                }
                if (sessionStorage.getItem('streamStatus') || this.streamStatus) {
                    this.$message.warning('请等待Ai生成完毕！')
                    return
                }
                if (!this.overview.trim() && this.btnStatus == 2) {
                    this.$message.warning('请填写章纲内容')
                    return
                }
                this.saveNovelChapter(i)
            }

        },
        //i=3保存ai章纲 、 i!=3生成ai章节正文
        saveNovelChapter(i) {
            try {
                sessionStorage.setItem('ifEditor', true)
                const editItem = JSON.parse(sessionStorage.getItem('editItem'))
                let params = {
                    id: editItem.chapterId,
                    overview: this.overview,
                    requirement: this.contentRequire
                }

                lNApi.longChapterOverviewSave(params).then((res) => {
                    if (res.code == 200) {
                        this.editorStatus = true
                        EventBus.$emit('headWrite')
                        // editItem.editText = 1
                        // sessionStorage.setItem('editItem', JSON.stringify(editItem))
                        // this.init()
                        if (i === 3) {
                            this.$message.success('章纲保存成功！')
                        } else if (i === 0 || i === 2) {
                            if (editItem.chapter == 1) {
                                this.$refs.textRequire.openPrompt('lnovel_start_text', '生成正文')
                            } else {
                                //是专业vip还有用户已经开启了长记忆就走长记忆的流式
                                if (this.zsVip(this.userInfo) && this.isOpenRecall(this.mixinNInfo)) {
                                    this.$refs.textRequire.openPrompt('lnovel_recall_text', '生成正文')
                                } else {
                                    this.$refs.textRequire.openPrompt('lnovel_text', '生成正文')
                                }
                            }

                        } else if (i === 1) {
                            this.$refs.textRequire.openPrompt('lnovel_hot_start', '爆款开头')
                        }
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
            } catch (error) {
                sessionStorage.setItem('ifEditor', false)
            }

        },
        // 3手写
        headWrite() {
            if (sessionStorage.getItem('streamStatus') || this.streamStatus) {
                this.$message.warning('请等待Ai生成完毕！')
                return
            }
            if (this.overview === '' && !this.editorStatus) {
                this.$message.warning('请输入内容')
                return
            }
            if (!this.editorStatus) {
                this.editorStatus = true
                this.headStatus = false
                this.saveNovelChapter(3)
                EventBus.$emit('headWrite')
            } else {
                this.editorStatus = false
                EventBus.$emit('disable')
            }
        },
        haveContent() {
            this.overview = ''
            this.editorStatus = true
            EventBus.$emit('headWrite')
        },
        // 换一换
        again() {
            if (sessionStorage.getItem('streamStatus') || this.streamStatus) {
                this.$message.warning('请等待Ai生成完毕！')
                return
            }
            //换一换 初始化取消ai生成的状态
            if (this.$refs.editorChapterRequire) {
                this.$refs.editorChapterRequire.open()
            }
        },
    }
}
</script>

<style>
#editor_textChapter {
    width: 28%;
    height: 100%;
    background: #FFFFFF;
    box-shadow: 0px 0 8px 0px rgba(117, 53, 0, 0.06);
    border-radius: 0px 8px 8px 0;
    position: relative;
}

.editor_text {
    width: 100%;
    padding: 0 25px;
    height: 67px;
    font-size: 15px;
    color: #444444;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E6EBF0;
}

.editor_text1 {
    display: flex;
}

.editor_text2 {
    margin-right: 15px;
    font-size: 16px;
}

.editor_text2_1 {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.editor_text3 {
    width: 75px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    background: var(--tech-primary);
    border-radius: 8px;
    font-size: 15px;
    color: #FFFFFF;
    cursor: pointer;
}

.editor_textChapter1 {
    width: 70px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    border-radius: 8px;
    border: 1px solid var(--tech-primary);
    color: var(--tech-primary);
    cursor: pointer;
}

.editor_textChapter1_1 {
    width: 115px;
    height: 36px;
    text-align: center;
    line-height: 36px;
    background: var(--tech-primary);
    border-radius: 8px;
    color: #FFFFFF;
}

.editor_textChapter2 {
    width: 100%;
    height: calc(100% - 138px);
    padding: 15px 25px;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.editor_textChapter2 .el-textarea__inner {
    font-size: 17px;
    color: #111111;
    border: none;
    resize: none;
    padding: 0;
    overflow-y: auto;
    height: 100%;
}

.editor_textChapter2 .el-textarea__inner::-webkit-scrollbar {
    display: none;
    font-size: 17px;
}

.editor_textChapter2 .el-textarea.is-disabled .el-textarea__inner {
    background-color: transparent;
    color: #111111;
}

.editor_textChapter2_1 {
    font-weight: bold;
    font-size: 18px;
    color: #111111;
    margin-bottom: 15px;
}

.editor_textChapter3 {
    width: 100%;
    height: 69px;
    padding: 0 15px;
    background: #FFFFFF;
    border-top: 1px solid #EEEEEE;
    display: flex;
    align-items: center;
    justify-content: center;
}

.editor_textChapter3_1 {
    width: 154px;
    height: 41px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    padding: 0;
}

.editor_textChapter3_2 {
    width: 176px;
    height: 38px;
    line-height: 38px;
    font-size: 15px;
    color: #FFFFFF;
    /* background: url('@/assets/image/icon_chapter2.png') no-repeat;
    background-size: 100% 100%;
    padding-left: 35px; */
    cursor: pointer;
}

.editor_textChapter4 {
    width: 100%;
    height: 69px;
    padding: 0 15px;
    background: #FFFFFF;
    border-top: 1px solid #EEEEEE;
    display: flex;
    align-items: center;
    justify-content: center;
}

.editor_textChapter4_1 {
    width: 125px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    border-radius: 8px;
    font-size: 15px;
    color: var(--tech-primary);
    border: 1px solid var(--tech-primary);
    margin-right: 20px;
}

.editor_textChapter4_1_1 {
    width: 125px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    border-radius: 8px;
    font-size: 15px;
    margin-right: 20px;
}

.editor_textChapter4_3 {
    margin-right: 0;
}

.editor_textChapter4_2 {
    width: 165px;
    height: 36px;
    text-align: center;
    line-height: 36px;
    background: var(--tech-primary);
    border-radius: 8px;
    font-size: 15px;
    color: #FFFFFF;
}
</style>